import httpClient from '../../shared/http/http-client';

export default class AdminAutomaticDeclineRuleService {
  http;

  constructor() {
    this.http = httpClient
  }

  async addDeclineRule(questionFormId, rule) {
    return this.http.post(`admin/question/question-form/${questionFormId}/decline-rule`, rule)
      .then(response => {
        return response.data;
      })
  }

  async deleteDeclineRule(questionFormId, ruleId) {
    return this.http.delete(`admin/question/question-form/${questionFormId}/decline-rule/${ruleId}`)
      .then(response => {
        return response.data;
      })
  }

}